<mat-form-field
    [floatLabel]="hasFloatingLabel ? 'always' : 'auto'"
    class="w-full"
    [color]="color"
    [arcErrorTooltip]="control"
    [subscriptSizing]="hasFixedSubscript ? 'fixed' : 'dynamic'">
    <mat-label>{{ label || (labelKey | transloco) }}</mat-label>
    <mat-select
        [formControl]="castedControl"
        (selectionChange)="onChange($event)"
        (blur)="onBlur()"
        [compareWith]="customComparator"
        [multiple]="isMultiselect"
        [placeholder]="placeholder || (placeholderKey | transloco)">
        @for (option of options; track option.value) {
            <mat-option [value]="option.value">
                {{ option.shouldTranslateLabel ? (option.label | transloco) : option.label }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
